import './NotificationRulesForm.scss';

export { default } from './NotificationRulesForm';
